import { jsxs, jsx } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ChatInput from "./components/ChatInput.js";
import SendButton from "./components/SendButton.js";
import { onClickSend, updateChat } from "./features/ChatActions.js";
import { withChatContext } from "./Context.js";
import { CHAT_STATUS } from "./constants/index.js";
class ChatInputContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserTyping: false
    };
    this.inputRef = React.createRef();
    this.onSendClick = this.onSendClick.bind(this);
    this.onChatChange = this.onChatChange.bind(this);
  }
  // NOTE: Removed due to Live issue
  // handleTyping({ dispatch, apiClient, isTyping }) {
  //  dispatch(updateChasitorTyping(apiClient, isTyping));
  //  this.setState({ isUserTyping: isTyping });
  // }
  onSendClick() {
    var _a, _b, _c, _d, _e, _f;
    if (((_b = (_a = this.props.chat) == null ? void 0 : _a.chatBot) == null ? void 0 : _b.sending) === true) {
      return;
    }
    this.props.dispatch(
      onClickSend({
        message: (_d = (_c = this.props.chat) == null ? void 0 : _c.chatBot) == null ? void 0 : _d.currentMessage,
        parcelCode: (_f = (_e = this.props.chat) == null ? void 0 : _e.config) == null ? void 0 : _f.parcelCode,
        apiClient: this.props.apiClient
      })
    );
  }
  onChatChange(message) {
    this.props.dispatch(updateChat(message));
  }
  render() {
    const inputDisabled = this.props.chat.chatBot.state === CHAT_STATUS.ADVISOR_ENDED;
    const sendDisabled = this.props.chat.chatBot.sending === true || inputDisabled;
    return /* @__PURE__ */ jsxs("div", { id: "chat-input", children: [
      /* @__PURE__ */ jsx(
        ChatInput,
        {
          ref: (re) => {
            this.inputRef = re;
          },
          onChange: this.onChatChange,
          onSubmit: this.onSendClick,
          value: this.props.chat.chatBot.currentMessage,
          disabled: inputDisabled
        }
      ),
      /* @__PURE__ */ jsx(SendButton, { onClick: this.onSendClick, disabled: sendDisabled })
    ] });
  }
}
ChatInputContainer.propTypes = {
  dispatch: PropTypes.func,
  config: PropTypes.object,
  chat: PropTypes.object,
  apiClient: PropTypes.object
};
function mapStateToProps(state) {
  return state;
}
const ChatInputContainer$1 = withChatContext(connect(mapStateToProps)(ChatInputContainer));
export {
  ChatInputContainer$1 as default
};
//# sourceMappingURL=ChatInputContainer.js.map
